
import {
	droughtColor,
	erosionColor,
	flashFloodColor,
	floodColor,
	hailColor,
	landslideColor,
	stormColor
} from '@/lib/common'
import { Vue, Component } from 'vue-property-decorator'

@Component({
	name: 'DisasterFilter',
	components: {}
})
export default class DisasterFilter extends Vue {
	readonly floodColor = `rgb(${floodColor.r}, ${floodColor.g}, ${floodColor.b})`
	readonly flashFloodColor = `rgb(${flashFloodColor.r}, ${flashFloodColor.g}, ${flashFloodColor.b})`
	readonly droughtColor = `rgb(${droughtColor.r}, ${droughtColor.g}, ${droughtColor.b})`
	readonly hailColor = `rgb(${hailColor.r}, ${hailColor.g}, ${hailColor.b})`
	readonly stormColor = `rgb(${stormColor.r}, ${stormColor.g}, ${stormColor.b})`
	readonly landslideColor = `rgb(${landslideColor.r}, ${landslideColor.g}, ${landslideColor.b})`
	readonly erosionColor = `rgb(${erosionColor.r}, ${erosionColor.g}, ${erosionColor.b})`

	get cloudBandOnly(): boolean {
		return this.$tStore.state.disasterFilter.cloudBandOnly
	}

	set cloudBandOnly(value: boolean) {
		Vue.set(this.$tStore.state.disasterFilter, 'cloudBandOnly', value)
	}

	get floods(): boolean {
		return this.$tStore.state.disasterFilter.floods
	}

	set floods(value: boolean) {
		Vue.set(this.$tStore.state.disasterFilter, 'floods', value)
	}

	get flashFloods(): boolean {
		return this.$tStore.state.disasterFilter.flashFloods
	}

	set flashFloods(value: boolean) {
		Vue.set(this.$tStore.state.disasterFilter, 'flashFloods', value)
	}

	get drought(): boolean {
		return this.$tStore.state.disasterFilter.drought
	}

	set drought(value: boolean) {
		Vue.set(this.$tStore.state.disasterFilter, 'drought', value)
	}

	get hail(): boolean {
		return this.$tStore.state.disasterFilter.hail
	}

	set hail(value: boolean) {
		Vue.set(this.$tStore.state.disasterFilter, 'hail', value)
	}

	get storms(): boolean {
		return this.$tStore.state.disasterFilter.storms
	}

	set storms(value: boolean) {
		Vue.set(this.$tStore.state.disasterFilter, 'storms', value)
	}

	get landslide(): boolean {
		return this.$tStore.state.disasterFilter.landslide
	}

	set landslide(value: boolean) {
		Vue.set(this.$tStore.state.disasterFilter, 'landslide', value)
	}

	get erosion(): boolean {
		return this.$tStore.state.disasterFilter.erosion
	}

	set erosion(value: boolean) {
		Vue.set(this.$tStore.state.disasterFilter, 'erosion', value)
	}
}
